import type {AddLeadContactFormPayload} from "./add-lead-contact.schema";
import type {ContactInput} from "@project/sdk/sales";

import {phoneMapper} from "../../../../../../../support/mappers/phone.mapper";

export const addLeadContactMapper = {
  toSdk(payload: AddLeadContactFormPayload): ContactInput {
    const base = {
      name: payload.name,
      ...(payload.description === undefined ? {} : {description: payload.description}),
    };

    if (payload.phone && payload.phonePrefix) {
      return {
        ...base,
        ...(payload.email ? {email: payload.email} : {}),
        phone: phoneMapper.toSdk(payload.phone, payload.phonePrefix),
      };
    }

    if (payload.email) return {...base, email: payload.email};

    throw new Error("Validated contact payload has no communication channel");
  },
};
